import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { CheckoutStatusType, CheckoutType } from 'types/checkout'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { fetchOrdersAction, setCheckoutUnsubscribesAction } from 'reducks/checkout/actions'
import { CheckoutItemType } from 'types/checkoutItem'
import {
  fetchBreadRefsByManufacturerRef,
  fetchCheckoutItemsByRef,
  mergeListeningCheckoutWithItems,
} from 'reducks/checkout/operations'
import { StockUnionType } from 'types/stock'

const fetchOrders = (
  date: string,
  orderStatus: string,
  orderTypes: StockUnionType[],
  status: CheckoutStatusType[],
  storeRef: FirebaseDocRefType,
  sortKey: 'checkout_at' | 'pickup_time' = 'checkout_at',
  sortOrder: 'asc' | 'desc' = 'desc'
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // unsubscribeがセットされている状態（リスナーがONの状態）であれば処理しない
    if (getState().checkout.is_set_unsubscribe) return

    dispatch(showLoadingAction())
    const manufacturerRef: FirebaseDocRefType = getState().auth.manufacturer_ref
    let breadRefs: FirebaseDocRefType[] = []
    const isSacriStationMode = typeof manufacturerRef !== 'undefined'

    // 販売元店舗がsacri stationを表示する場合、自店舗の決済のみに絞り込む
    if (isSacriStationMode) {
      breadRefs = await fetchBreadRefsByManufacturerRef(storeRef, manufacturerRef)
      if (breadRefs.length === 0) {
        dispatch(fetchOrdersAction([]))
        dispatch(hideLoadingAction())
        return
      }
    }

    // ステータスに応じてクエリを作成する
    const query = storeRef.collection('store_checkouts').where('date', '==', date).where('status', 'in', status)

    const unsubscribe = await query.onSnapshot(async (snapshots) => {
      const itemPromises: Promise<CheckoutItemType[]>[] = []
      // データの追加のみ監視する
      const changes = snapshots.docChanges().filter((change) => {
        const data = change.doc.data() as CheckoutType
        // 注文ステータスに応じて表示する注文を絞り込む
        switch (orderStatus) {
          case '準備が必要':
            return change.type === 'added' && orderTypes.includes(data.type) && !data.is_prepared && !data.is_delivered
          case '準備済':
            return change.type === 'added' && orderTypes.includes(data.type) && data.is_prepared && !data.is_delivered
          case '受渡済':
            return change.type === 'added' && orderTypes.includes(data.type) && data.is_delivered
          case '発送済':
            return change.type === 'added' && orderTypes.includes(data.type) && data.is_delivered
          default:
            return change.type === 'added' && orderTypes.includes(data.type)
        }
      })
      changes.forEach((change) => {
        itemPromises.push(fetchCheckoutItemsByRef(change.doc.ref, breadRefs))
      })
      const result = await Promise.all(itemPromises).catch((error) => {
        throw new Error(`注文商品の一括取得に失敗: ${error}`)
      })
      const items = result.reduce((prev, _items) => [...prev, ..._items], [])
      const currentOrders = getState().checkout.orders
      mergeListeningCheckoutWithItems(changes, items, currentOrders, dispatch, sortKey, sortOrder)
    })

    dispatch(setCheckoutUnsubscribesAction([unsubscribe]))
    dispatch(hideLoadingAction())
  }
}

export default fetchOrders
